import Vue from "vue";
import VueResource from "vue-resource";

Vue.use(VueResource);

export const contacts = Vue.resource(
  "shipping/contact.svc",
  {},
  {
    list:   { method: "get",    url: "shipping/contact.svc?l={limit}&o={offset}&q={query}&s={sort}" },
    create: { method: "post",   url: "shipping/contact.svc" },
    load:   { method: "get",    url: "shipping/contact/{id}.svc" },
    save:   { method: "post",   url: "shipping/contact/{id}.svc" },
    delete: { method: "delete", url: "shipping/contact/{id}.svc" }
  }
);

/** Process attachments (now limited to PODs)
 * @param {string} id shipmentId
 * @param {string} at attachmentId
 * @param {string} iv invoiceId TODO: backend support; decide param name
 */
export const attachments = Vue.resource(
  "",
  {},
  {
    // List
    podInfo:           { method: "GET", url: "shipment/{shipmentId}/pod.svc" },
    // Download
    podLoad:           { method: "GET", url: "shipment/{shipmentId}/pod/{attachmentId}.svc",          responseType: "arraybuffer" },
    podLoadByShipment: { method: "GET", url: "shipment/{shipmentId}/pod/all.svc?manifest={manifest}", responseType: "arraybuffer" },
    podLoadByInvoice:  { method: "GET", url:   "invoice/{invoiceId}/pod/all.svc" },
    // ------------ doc/pod/pkg
    list:           { method: "GET",  url: "shipment/{shipmentId}/attachment/{attachmentType}.svc" },
    upload:         { method: "POST", url: "shipment/attach.svc" },
    //upload:         { method: "POST", url: "shipment/{shipmentId}/attachment/{attachmentType}/{attachmentId}.svc" },
    download:       { method: "GET",    url: "shipment/{shipmentId}/attachment/{attachmentType}/{attachmentId}.svc", responseType: "arraybuffer" },// all: attachmentId=all
    delete:         { method: "DELETE", url: "shipment/{shipmentId}/attachment/{attachmentType}/{attachmentId}.svc" }// all: attachmentId=all
  }
);

export const tracking = Vue.resource(
  "shipment/tracking.svc",
  {},
  {
    track: { method: "GET", url: "shipment/tracking.svc?id={id}{&mode=mode*}" },// was ?manifest={id}
    route: { method: "GET", url: "shipment/route-tracking/{id}.svc" }
  }
);

export const stat = Vue.resource(
  "statistics.svc",
  {},
  {
    shipments : { method : "POST", url : "statistics/report.svc" },
    totals    : { method : "GET",  url : "statistics/totals.svc" }
  }
);

export const shipments = Vue.resource(
  "shipments.svc",
  {},
  {
    list           : { method: "GET",    url: "shipment.svc?l={length}&o={offset}{&state.code*}{&service_type*}" },
    xls            : { method: "GET",    url: "shipment.svc?export=excel{&state.code*}{&service_type*}", responseType: "arraybuffer" },
    findManifest   : { method: "GET",    url: "shipment.svc?l={length}&o=0&manifest={manifest}&sort=manifest" },
    printManifest  : { method: "POST",   url: "print/manifest.svc", responseType: "arraybuffer" },
    printLabel     : { method: "POST",   url: "print/label.svc", responseType: "arraybuffer" },
    request        : { method: "POST",   url: "shipment/request.svc" },
    create         : { method: "POST",   url: "shipment.svc{?wms_order_code*}" },
    load           : { method: "GET",    url: "shipment/{id}.svc" },
    save           : { method: "POST",   url: "shipment/{id}.svc{?wms_order_code*}" },
    cancel         : { method: "DELETE", url: "shipment/{id}.svc" },
    price          : { method: "POST",   url: "shipment/price.svc" },
    allowExtraList : { method: "GET",    url: "shipment/allow-extra-list.svc" },
    workdate       : { method: "POST",   url: "day-classification.svc" },
    dates          : { method: "POST",   url: "shipment/deliverydate.svc" },
    listStates     : { method: "GET",    url: "catalog/states.svc?enabled" },
    packagings     : { method: "GET",    url: "catalog/packaging.svc" },
    countries      : { method: "GET",    url: "catalog/countries.svc" },
  }
);

export const cod = Vue.resource(
  "report/cash-on-delivery.svc",
  {},
  {
    report : { method : "POST", url : "report/cash-on-delivery.svc"},
    xls    : { method : "POST", url : "report/cash-on-delivery.svc?export=excel", responseType: "arraybuffer" }
  }
);

export const invoice = Vue.resource(
  "invoice.svc",
  {},
  {
    list     : { method : "POST", url : "invoice.svc" },
    xls      : { method : "POST", url : "invoice.svc?export=excel", responseType: "arraybuffer" },
    load     : { method : "GET",  url : "invoice/{id}.svc?length={length}&offset={offset}" },
    loadXls  : { method : "GET",  url : "invoice/{id}.svc?export=excel", responseType: "arraybuffer" },
    printPdf : { method : "GET",  url : "invoice/{id}.svc?export=pdf",   responseType: "arraybuffer" }
  }
);

export const wms = Vue.resource(
  "",
  {},
  {
    suggestWarehouse:     { method: "GET", url: "suggest/wms-station.svc" },
    suggestCustomer:      { method: "GET", url: "suggest/wms-customer.svc" },
    generateCustomerCode: { method: "GET", url: "wms-generate-customer-code.svc" },
    list:        { method: "GET",  url: "wms-products.svc?code={code}&name={name}&wms_station_code={wms_station_code}" },
    xlsProducts: { method: "GET",  url: "wms-products.svc?export=excel", responseType: "arraybuffer" },
    check:       { method: "POST", url: "wms-check-products.svc" },
    order:       { method: "POST", url: "wms-create-order.svc" },
    listOrders:  { method: "GET",  url: "wms-list-orders.svc?start_date={start_date}{&end_date}" },
    xlsOrders:   { method: "GET",  url: "wms-list-orders.svc?export=excel", responseType: "arraybuffer" },
    cancel:      { method: "POST", url: "wms-cancel-order.svc" },
    getPicked:   { method: "GET",  url: "wms-order-products.svc?order_code={order_code}&is_completed=true" },
    xlsOrderProducts: { method: "GET",  url: "wms-order-products.svc?export=excel&order_code={order_code}&is_completed={is_completed}", responseType: "arraybuffer" },
  }
);

export const consumables = Vue.resource(
  "",
  {},
  {
    list:       { method: "GET",  url: "consumables/list.svc"  },
    order:      { method: "POST", url: "consumables/order.svc" },
    listOrders: { method: "GET",  url: "consumables/list-orders.svc?start_date={start_date}{&end_date}" },
  }
);

export const suggest = Vue.resource(
  "suggest",
  {},
  {
    suggestContact    : { method : "POST", url : "suggest/contact.svc" },
    suggestSettlement : { method : "GET",  url : "suggest/settlement.svc?q={q}" },
    suggestOffice     : { method : "GET",  url : "suggest/office.svc?q={q}&settlement_id={settlement}" },
    suggestStation    : { method : "GET",  url : "suggest/station-servicing.svc?id={settlement_code}" },
    dangerousGoods    : { method : "GET",  url : "suggest/dangerous-goods.svc?q={filter}" },
    packagingDgs      : { method : "GET",  url : "suggest/packaging-dgs.svc?q={filter}" }
  }
);

export const user = Vue.resource(
  "user/info.svc",
  {},
  {
    save: { method: "POST", url: "user/info.svc" },
    pass: { method: "POST", url: "user/password.svc" }
  }
);

export const settings = Vue.resource(
  "settings.svc",
  {},
  {
    load: { method: "GET",  url: "settings.svc" },
    save: { method: "POST", url: "settings.svc" }
  }
);

export const template = Vue.resource(
  "shipment/import.jac",
  {},
  {
    meta: { method: "GET", url: "shipment/import.jac?meta" },
    get:  { method: "GET", url: "shipment/import.jac" }
  }
);

export const notifications = Vue.resource(
  "notifications.svc",
  {},
  {
    get: { method: "GET", url: "notifications.svc?since={since}&until={until}" }
  }
);

export const register = Vue.resource(
  "", {},
  {
    validate: { method: "POST", url: process.env.VUE_APP_API_PATH + "/integration/customer-centre/self-service/validate.svc" },
    generate: { method: "POST", url: process.env.VUE_APP_API_PATH + "/integration/customer-centre/self-service/generate.svc" },
    progress: { method: "POST", url: process.env.VUE_APP_API_PATH + "/integration/customer-centre/self-service/progress.svc" },
    password: { method: "POST", url: process.env.VUE_APP_API_PATH + "/integration/customer-centre/self-service/password.svc" }
  }
);

export const cases = Vue.resource(
  "", {},
  {
    list: { method: "GET", url: "wfcs/list.svc?length={length}&offset={offset}{&manifest}{&after}{&until}" },
  }
);

export const dangerousGoodsImagePath = "resource/image.svc"
export const resources = Vue.resource(
  "", {},
  {
    dangerousGoodsImage: { method: "GET", url: dangerousGoodsImagePath + "?name={name}", responseType: "arraybuffer" },
  }
);